import { erroIndisponibilidade } from 'helpers/Constantes/Mensagens'
import * as S from './index.style'

const Erro: React.FC = () => (
  <S.Wrapper data-cy="erro">
    <S.Mensagem>
      <S.Icone />
      <S.Texto>
        {erroIndisponibilidade}
        <br />
        <span>
          Se o problema persistir, solicite ajuda pelo <a href="https://helpdesk.mrv.com.br/">Help Desk</a>.
        </span>
      </S.Texto>
    </S.Mensagem>
  </S.Wrapper>
)

export default Erro
